// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:1a329cbf-bee7-48ba-99b5-e66de8ba6466",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_66wCRvGZy",
    "aws_user_pools_web_client_id": "2vg6houmak0299sj83e73umkjf",
    "oauth": {},
    "aws_content_delivery_bucket": "clearinghousehosting-master",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d9vduoff7jec4.cloudfront.net",
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "recipients-master",
            "region": "us-east-1"
        },
        {
            "tableName": "organizations-master",
            "region": "us-east-1"
        },
        {
            "tableName": "duplicates-master",
            "region": "us-east-1"
        }
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "recipients",
            "endpoint": "https://8qd9q133l4.execute-api.us-east-1.amazonaws.com/master",
            "region": "us-east-1"
        },
        {
            "name": "users",
            "endpoint": "https://fi8pnooj2h.execute-api.us-east-1.amazonaws.com/master",
            "region": "us-east-1"
        },
        {
            "name": "organizations",
            "endpoint": "https://qd2ovj36wb.execute-api.us-east-1.amazonaws.com/master",
            "region": "us-east-1"
        },
        {
            "name": "duplicates",
            "endpoint": "https://6qztntpvld.execute-api.us-east-1.amazonaws.com/master",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
